﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { MatriculadoService } from './../_services/matriculado.service';
import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/first';

import { VentaRespuesta, Page, MatriculadoRegistro } from '../_models/index';
import { UserService } from '../_services/index';
import { ComprobanteService } from '../_services/comprobante.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
//import { PagoFacilAuthService } from '../_services/pago-facil-auth.service';
import { PagoFacilService } from '../_services/pago-facil.service';

@Component({
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})

export class HomeComponent implements OnInit {
    respuesta: VentaRespuesta = new VentaRespuesta;
    page: Page;
    _prevPage: Page;
    thereIsPrev = false;
    thereIsNext = false;
    loading = false;
    popUpBlocked =  false;
    serverError = false;
    matriculado: MatriculadoRegistro;
    templates: any = {
        'Cuota Societ': 'cuota',
        'Nota de Créd': 'nota',
        'Factura': 'factura',
        'Deuda en Jui': 'deuda',
        'Novación': 'novacion',
        'Deuda Mediac': 'dmediacion',
        'Galenos': 'galenos'
    };
    constructor(private userService: UserService,
                private comprobanteService: ComprobanteService,
                private matriculadoService: MatriculadoService,
    //            private pagoFacilAuth: PagoFacilAuthService,   // 👈 agregado
                private pagoFacilService: PagoFacilService,  
                private router: Router) {
        this.page = new Page();
        this._prevPage = new Page();
        this.page.from = 1;
        this.page.to = 20;
        this.serverError = false;
     }

    ngOnInit() {
        // get users from secure api end point
        this.loading = true;
        this.userService.getVentas(this.page)
            .first()
            .subscribe(datos => {
                let curr_date = new Date();
                datos.registros.forEach(registro => {
                    registro["show_download"] = true;                       
                    if (registro["fec_vcto"] !== undefined && registro["fec_vcto"] !== null)
                    {
                        let vencimiento_date = new Date(registro.fec_vcto + ' 12:00:00');
                        registro["fact_vencida"] = vencimiento_date < curr_date;
                    }
                    else
                    {
                        registro["fact_vencida"] = false;
                    }

                });
                this.respuesta = datos;
                this.checkPagination();
                this.loading = false;
            },
            error => {
                this.redirectLogin(error);
            });

        this.loadMatriculado();
    }

    dateFormat(date: string): string {
        const d = String(date);
        return d.substr(8, 2) + '-' + d.substr(5, 2) + '-' + d.substr(0, 4);
        //return date;
    }

    checkPagination() {
        if (this.respuesta.proximoRangoRegistros !== undefined) {
            this.thereIsNext = true;
            const from = parseInt(this.respuesta.proximoRangoRegistros.split('..')[0], 10);
            console.log(from);
            if (from === 21) {
                this.thereIsPrev = false;
            } else if ( from > 21) {
                this.thereIsPrev = true;
            }
        } else {
            this.thereIsNext = false;
        }
    }

    nextPage() {
        this.loading = true;
        this.page.from = parseInt(this.respuesta.proximoRangoRegistros.split('..')[0], 10);
        this.page.to = this.page.from + 19;
        this.userService.getVentas(this.page)
            .first()
            .subscribe(datos => {
                this.respuesta = datos;
                this.checkPagination();
                this.loading = false;
            },
            error => {
                this.redirectLogin(error);
            });
    }

    prevPage() {
        this.loading = true;
        this._prevPage.from = parseInt(this.respuesta.proximoRangoRegistros.split('..')[0], 10) - 40;
        if ( this._prevPage.from < 0) {
            this._prevPage.from = 0;
        }
        this._prevPage.to = this._prevPage.from + 19;
        this.userService.getVentas(this._prevPage)
            .first()
            .subscribe(datos => {
                this.respuesta = datos;
                this.checkPagination();
                this.loading = false;
            },
            error => {
                this.redirectLogin(error);
            });
    }
    getComprobante(i: number, today: boolean) {
        this.loading = true;
        this.respuesta.registros[i].downloading = true;
        this.generateRecipe(i, today);
        // const matriculado = sessionStorage.getItem('matriculado');
        // if ( matriculado === null ) {
        //     this.matriculadoService.getInfo().first().subscribe(datos => {
        //         this.matriculado = datos.registros[0];
        //         sessionStorage.setItem('matriculado', JSON.stringify(datos.registros[0]));
        //         this.generateRecipe(i, today);
        //     });
        // } else {
        //     this.matriculado = JSON.parse(matriculado);
        //     this.generateRecipe(i, today);
        // }
    }

    loadMatriculado() {
        const matriculado = sessionStorage.getItem('matriculado');
        if ( matriculado === null ) {
            this.matriculadoService.getInfo().first().subscribe(datos => {
                this.matriculado = datos.registros[0];
                sessionStorage.setItem('matriculado', JSON.stringify(datos.registros[0]));
            });
        } else {
            this.matriculado = JSON.parse(matriculado);
        }   
    }

    redirectPagoFacil(i: number, today: boolean) {
    this.loading = true;
    let barcode = this.comprobanteService.generateBarcode(this.respuesta.registros[i], this.matriculado, true, this.respuesta.registros[i].fec_vcto);
    let barcode_validate = ((barcode.length % 2 === 0) ? '0' : '') + barcode + this.comprobanteService.barcode2of5(barcode);
    const ahora = new Date();
    ahora.setHours(ahora.getHours() + 1); // suma 1 hora
    const hoy = ahora.toISOString();

        //let codigo: HTMLInputElement = document.createElement("input");
        //codigo.type = "text";
        //codigo.id = "codigo_barra";
        //codigo.name = "codigo_barra";
        //codigo.value = barcode_validate;

        //let adicional: HTMLInputElement = document.createElement("input");
        //adicional.type = "text";
        //adicional.id = "dato_adicional_1";
        //adicional.name = "dato_adicional_1";
        //adicional.value = "";

        //form.appendChild(key);
        //form.appendChild(codigo);
        //form.appendChild(adicional);
        //document.body.appendChild(form);
        
        //document.body.removeChild(form);
        //form.removeChild(key);
        //form.removeChild(codigo);
        //form.removeChild(adicional);
    
        const body = {
        datosBusqueda: {
        datosEscaneo: barcode_validate
        },
        motivo: "Pago de matrícula",
        referencia: "Matricula-" + this.matriculado.nromatricu,
        //fechaVencimiento: this.respuesta.registros[i].fec_vcto,
        fechaVencimiento: hoy,
        habilitaQR: true,
        habilitaTransferencia: true,
        habilitaTarjeta: true
    };

    this.pagoFacilService.generarIntencionPago(body).subscribe(
        resp => {
        this.loading = false;
        console.log('Link de pago:', resp.url);
        window.open(resp.url, '_blank');
        },
        error => {
        this.loading = false;
        console.error('Error al generar intención de pago', error);
        }
    );    
    }
    /*
    const body = {
        datosBusqueda: {
        datosEscaneo: this.respuesta.registros[i].pago_facil
        },
        motivo: "Pago de matrícula",
        referencia: "Matricula-" + this.matriculado.nromatricu,
        fechaVencimiento: this.respuesta.registros[i].fec_vcto,
        habilitaQR: true,
        habilitaTransferencia: true,
        habilitaTarjeta: true
    };

    this.pagoFacilService.generarIntencionPago(body).subscribe(
        resp => {
        this.loading = false;
        console.log('Link de pago:', resp.url);
        window.open(resp.url, '_blank');
        },
        error => {
        this.loading = false;
        console.error('Error al generar intención de pago', error);
        }
    );*/
    
    generateRecipe(i: number, today: boolean) {
        this.comprobanteService.getComprobante(this.respuesta.registros[i], this.matriculado, today)
        .first()
        .subscribe(
            datos => {
                this.serverError = false;
                this.respuesta.registros[i].downloading = false;
                this.loading = false;
                const a = document.createElement('a');
                const container = document.getElementById('downloadPDFContainer');
                // TODO: Remove child before add new element.
                a.setAttribute("download", "comprobante.pdf");
                a.setAttribute( "href", datos.filename );
                container.appendChild(a);
                a.click();
            },
            error => {
                console.error(error);
                this.serverError = true;
                this.respuesta.registros[i].downloading = false;
                this.loading = false;
            }
        );
    }
    concepto(c: string, o: string) {
        // if (this.templates[c] !== undefined && this.templates[c] === "nota")
        // {
        //     return "NOTA DE CREDITO";
        // }
        let concepto: string = c.split(' ')[0].toUpperCase();
        let observacion: string = o.toLocaleUpperCase();
        if (concepto.includes('CUOTA'))
        {
            if(observacion.includes('ANUAL'))
            {
                concepto +=" ANUAL";
            }
        }
        return concepto;
    }

    redirectLogin(error: any) {
        if (error.status === 401 ) {
            this.router.navigate(['/login']);
        }
        this.loading = false;
    }

    getTemplate(registro: any)
    {
        // console.log(registro);
        if (this.templates[registro.formulario] !== undefined)
        {
            return this.templates[registro.formulario];
        }
        else 
        {
            return this.templates['Cuota Societ'];
        }
    }
}
